import * as THREE from 'three';
import { AUDIO } from '../config';

/**
 * 2D 배경음악 베드 (THREE.Audio = Web Audio 래퍼, WebXR에서도 동작).
 * 브라우저 자동재생 정책 때문에 사용자 제스처(입장 클릭/VR 진입)에서 start()로 시작한다.
 * 게인은 ShowDirector가 쇼 엔벨로프(인트로 페이드인 → 끝 페이드아웃)에 맞춰 구동한다.
 * 루프는 ShowDirector가 restart()로 쇼 루프에 동기(암전 중 무음에서 되감김).
 */
export class AudioBed {
  private readonly audio: THREE.Audio;
  private started = false;
  private ready = false;

  constructor(listener: THREE.AudioListener) {
    this.audio = new THREE.Audio(listener);
    this.audio.setLoop(false); // 쇼 루프에 맞춰 수동 restart
    this.audio.setVolume(0);

    new THREE.AudioLoader().load(
      `${import.meta.env.BASE_URL}${AUDIO.path}`,
      (buffer) => {
        this.audio.setBuffer(buffer);
        this.ready = true;
        if (this.started && !this.audio.isPlaying) this.audio.play();
      },
      undefined,
      (error) => console.warn(`BGM 로드 실패: ${AUDIO.path}`, error),
    );
  }

  /** 사용자 제스처에서 호출 — AudioContext 재개 + 재생 시작. 멱등. */
  start(): void {
    this.started = true;
    const ctx = THREE.AudioContext.getContext() as AudioContext;
    if (ctx.state === 'suspended') void ctx.resume();
    if (this.ready && !this.audio.isPlaying) this.audio.play();
  }

  /** 0 = 무음, 1 = 마스터 볼륨. */
  setGain(value: number): void {
    this.audio.setVolume(value * AUDIO.volume);
  }

  /** 쇼 루프 재시작 시 곡을 처음으로 되감아 동기화. */
  restart(): void {
    if (!this.ready || !this.started) return;
    if (this.audio.isPlaying) this.audio.stop();
    this.audio.play();
  }
}
